<template>
  <div>
    <div style="font-size:14px;font-weight: bold">
      Material Type{{ rightFlag }}：
    </div>
    <div class="temperature">
      <div class="mt-4 van-row flex">
        <van-radio-group
            v-model="value.materialType2"
            direction="horizontal"
            @change="onMaterialChange"
        >
          <van-radio :name="1" checked-color="#8866f5">SS316</van-radio>
          <van-radio :name="2" checked-color="#8866f5">SS904</van-radio>
        </van-radio-group>
      </div>

      <div v-if="showBaseR" style="margin-top:20px;">
        Base R1 = {{ doubleR1 }}Ω
      </div>
      <!-- 曲线2 -->
      <div class="temperature-container">
        <div style="display: flex; flex-direction: row">
          <div style="display: flex; flex: 1;flex-direction: column;">
            <div class="flex-col-center">
              <div>Temperature Left</div>
              <van-stepper
                  style="margin-top:10px"
                  step="10"
                  v-model="value.temperature"
                  @change="onTemperateChange('t')"
                  min="0"
                  max="1000"
              />
            </div>
            <div class="flex-col-center" style="margin-top:10px">
              <div>Temperature Center</div>
              <van-stepper
                  style="margin-top:10px"
                  step="10"
                  v-model="value.temperature2"
                  @change="onTemperateChange('t')"
                  min="0"
                  max="1000"
              />
            </div>

            <div class="flex-col-center" style="margin-top:10px">
              <div>Temperature Right</div>
              <van-stepper
                  style="margin-top:10px"
                  step="10"
                  v-model="value.temperature3"
                  @change="onTemperateChange('t')"
                  min="0"
                  max="1000"
              />
            </div>
          </div>
          <div style="display: flex;flex-direction: column;align-items: center;justify-content: center">
            <div style="display: flex;flex-direction: column;align-items: center;justify-content: center">

              <div class="flex-col-center">
                <div>Push Power(W)</div>
                <div>
                  <input
                      style="width:100px;text-align: center"
                      v-model.number="value.pushPower"
                      @input="onTemperateChange('p1')"
                  />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { BLUETOOTH_MODULE_NAME } from "@/bluetooth/store/StoreType";

export default {
  name : "TripleTemperatureSetting",
  props: {
    value              : {
      type   : Object,
      require: true
    },
    showBaseR          : {
      type   : Boolean,
      default: true
    },
    doubleCartridgeMode: {
      type   : Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods : {
    onMaterialChange(e) {
      this.value.materialType2 = e;
      this.$store.commit(`${BLUETOOTH_MODULE_NAME}setMaterialType2`, e);
      this.$emit("input", this.value);
    },
    onTemperateChange(type, index) {
      switch (type) {
        case "t":
          break;
        case "p1":
          if (this.value.pushPower > 10) {
            this.value.pushPower = 10;
          }
          break;
      }
      this.$emit("input", this.value);
    }
  },
  computed: {
    ...mapState("bluetooth", ["r1", "doubleR1", "doubleR2"]),
    rightFlag() {
      if (this.doubleCartridgeMode) {
        return "(Right)";
      }
    }
  }
};
</script>

<style scoped lang="less">
.temperature {
  font-size: 14px;
  margin: 10px;
  padding: 20px;
  background: white;
  border-radius: 12px;
  display: flex;
  flex-direction: column;

  .temperature-container {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }
}
</style>
